// @flow

import React from 'react';
import { Flex, Button, SPACING } from 'clark-styles';
import { type SessionType } from 'types/sessions';

type PropsType = {
  handleDeleteSession: ({ shouldUpdateFutureSessions: boolean }) => void,
  remainingRecurringSessions: SessionType[],
};

const RecurrenceGroupingButtons = ({
  handleDeleteSession,
  remainingRecurringSessions,
}: PropsType) => (
  <Flex flexDirection="column">
    <Button
      margin={`0 0 ${SPACING.S_1}`}
      onClick={() => handleDeleteSession({ shouldUpdateFutureSessions: false })}
      layout="fullWidth"
      styleType="solid"
    >
      Only this instance
    </Button>
    <Button
      onClick={() => handleDeleteSession({ shouldUpdateFutureSessions: true })}
      layout="fullWidth"
      styleType="outlineSecondary"
    >
      {`This and ${remainingRecurringSessions.length - 1} following sessions`}
    </Button>
  </Flex>
);

export default RecurrenceGroupingButtons;



// WEBPACK FOOTER //
// ./src/containers/sessions/delete-modal/recurrence-grouping-buttons/index.js